import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Ticket } from "lucide-react";

const LINKS = [
  { label: "HOME", to: "/" },
  { label: "EVENTS", to: "/upcomingshows" },
  { label: "YATRA", to: "/yatra" },
  { label: "VIDEOS", id: "#watch" },
  { label: "GALLERY", id: "#glimpses" },
  { label: "ABOUT", id: "#about" },
  { label: "BOOKINGS", to: "/bookprivateshow" },
  { label: "CONTACT", to: "/contact" },
];

export const Logo = () => (
  <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
    <span className="w-11 h-11 rounded-full border-2 border-saffron flex items-center justify-center text-saffron font-serif text-xl">ॐ</span>
    <span className="leading-tight">
      <span className="block text-[10px] font-display tracking-[0.3em] text-ash">THE BAND</span>
      <span className="block font-display text-2xl tracking-[0.08em] text-gold">SUMIRAN</span>
      <span className="block text-[9px] tracking-[0.35em] text-ash font-hindi">भक्ति • संगीत • समर्पण</span>
    </span>
  </Link>
);

export default function Nav({ scrollTo }) {
  const [open, setOpen] = useState(false);
  const go = (id) => { setOpen(false); scrollTo && scrollTo(id); };
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-ink/85 border-b border-bone/10" data-testid="main-nav">
      <div className="flex items-center justify-between px-5 md:px-10 h-[84px]">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            l.to ? (
              <Link key={l.label} to={l.to}
                className="text-[11px] font-medium tracking-[0.18em] text-bone/80 hover:text-gold transition-colors"
                data-testid={`nav-link-${l.label.toLowerCase()}`}>
                {l.label}
              </Link>
            ) : (
              <button key={l.label} onClick={() => go(l.id)}
                className="text-[11px] font-medium tracking-[0.18em] text-bone/80 hover:text-gold transition-colors"
                data-testid={`nav-link-${l.label.toLowerCase()}`}>
                {l.label}
              </button>
            )
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <Link to="/book"
            className="hidden sm:flex items-center gap-2 px-6 py-2.5 bg-saffron text-ink text-xs font-bold tracking-[0.12em] rounded-full hover:bg-gold transition-colors"
            data-testid="nav-book-tickets-btn">
            BOOK TICKETS <Ticket size={14} />
          </Link>
          <button className="lg:hidden text-bone" onClick={() => setOpen(!open)} data-testid="nav-menu-toggle">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-bone/10 bg-ink/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            l.to ? (
              <Link key={l.label} to={l.to} onClick={() => setOpen(false)} className="text-left text-sm tracking-[0.15em] text-bone/80 hover:text-gold transition-colors" data-testid={`nav-mobile-${l.label.toLowerCase()}`}>
                {l.label}
              </Link>
            ) : (
              <button key={l.label} onClick={() => go(l.id)} className="text-left text-sm tracking-[0.15em] text-bone/80 hover:text-gold transition-colors" data-testid={`nav-mobile-${l.label.toLowerCase()}`}>
                {l.label}
              </button>
            )
          ))}
          <Link to="/book" className="px-6 py-3 bg-saffron text-ink text-xs font-bold tracking-[0.12em] rounded-full w-fit" data-testid="nav-mobile-book-tickets-btn">
            BOOK TICKETS
          </Link>
        </nav>
      )}
    </header>
  );
}
